export default __webpack_public_path__ + "fonts/fb72e1054a79e91c511e9a8f8984e41a.ttf";